import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  DeleteRecord,
  SuccessAlert,
  URLPRIFIX,
  ErrorAlert,
  baseurl,
} from "../../functions/api";
import axios from "axios";
import { useStore } from "../../Components/StateProvider";
import Filters from "../../Components/Fields/Filters";
import Pagination from "../../Components/Fields/Pagination";
import { getlocal } from "../../functions/localstorage";
import { FaSearch, FaSortAlphaDown, FaSortAlphaDownAlt, FaStar } from "react-icons/fa"; // Import FaStar for the badge icon

const BadgeTaskList = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  
  const queryParams = new URLSearchParams(location.search);
  const user = getlocal("system")?.user || {};
  const { id } = useParams();

  const [activeTab, setActiveTab] = useState("all");
  const [selectedRecords, setSelectedRecords] = useState([]); // State to hold selected records for bulk actions
  const [hasNoRecords, setHasNoRecords] = useState(false); // New state to track if no records are found

  const tablename = "tasks";
  const tableURL = "/badges/getbyuserid/" + id;

  const [filters, setFilters] = useState({});
  const [sortConfig, setSortConfig] = useState({
    field: "",
    direction: "asc",
  });
  const [localSearch, setLocalSearch] = useState("");

  const Tablehead = " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[16px] xl:text-[20px] font-bold ";
  const Tablerecord = " pr-[10px] max-sm:text-[26px] md:text-[20px] lg:text-[12px] xl:text-[16px] overflow-hidden";
  const width = "100%";
  const height = "90%";

  const Header = [
    ["Task", "subtask_title"],
    ["Type", "type"],
    ["Approved By", "approved_by"],
    ["Completed Date", "completed_date"],
    ["Badge", "hasBadge"], 
  ];

  const store = useStore();
  const init = {
    filterfield: "all",
    search: "",
    sort: "desc",
    currentpage: 1,
    totalpage: 1,
    pagesize: 20,
  };

  useEffect(() => {
    // store.setmodule("nonlitigation_tasks", init);
    store.setmodule("dashboard",init);
    store.stopLoading();
    store.setheader(tablename + " List");
    store.setvalue("defaultpagesize", init.pagesize);

    GetListview({
      listUrl: tableURL,
      store: store,
      field: queryParams.get("field") || init.filterfield,
      search: queryParams.get("search") || init.search,
      sort: queryParams.get("sort") || init.sort,
      pagesize: queryParams.get("pagesize") || init.pagesize,
    });

    store.setvalue("search", init.search);
    store.setvalue("filterfield", init.filterfield);
    store.setvalue("pagesize", init.pagesize);
  }, [queryParams.get("search"), queryParams.get("field"), id]);

 

  function change(props) {
    store.setvalue("filterfield", props.field);
    store.setvalue("search", props.search);
    store.setvalue("pagesize", props.pagesize || store.getvalue("pagesize"));
    store.setvalue("currentpage", 1);

    GetListview({
      listUrl: tableURL,
      store: store,
      field: props.field,
      search: props.search,
      sort: props.sort,
      page: 1,
      pagesize: props.pagesize || store.getvalue("pagesize"),
    });
  }

  function onpage(page, pagesize = store.getvalue("pagesize")) {
    GetListview({
      listUrl: tableURL,
      store: store,
      field: store.getvalue("filterfield"),
      search: store.getvalue("search"),
      sort: store.getvalue("sort"),
      page: page,
      pagesize: pagesize,
    });
  }

  const statusTabs = store.getvalue("statuscount") || [];

  const handleOnSelect = (itemOrItems, isChecked) => {
    if (Array.isArray(itemOrItems)) {
      if (isChecked) {
        setSelectedRecords([...itemOrItems]);
      } else {
        setSelectedRecords([]);
      }
    } else {
      if (isChecked) {
        setSelectedRecords((prevSelected) => [...prevSelected, itemOrItems]);
      } else {
        setSelectedRecords((prevSelected) =>
          prevSelected.filter((record) => record.id !== itemOrItems.id)
        );
      }
    }
  };

  const handleBulkAssign = (itemsToAssign) => {
    console.log("Bulk Assign these items:", itemsToAssign);
    alert(`Assigning ${itemsToAssign.length} items! (Implement API call here)`);
    setSelectedRecords([]);
    GetListview({
      listUrl: tableURL,
      store: store,
      field: store.getvalue("filterfield"),
      search: store.getvalue("search"),
      sort: store.getvalue("sort"),
      page: store.getvalue("currentpage"),
      pagesize: store.getvalue("pagesize"),
    });
  };

  const handleClickRow = (item) => {
    console.log("Row clicked:", item);
    if (store.getprops("view")) {
      if(item.type_id==11){
      store.navTo(`/${URLPRIFIX}/${tablename}/view/${item.task_id}`);
      }else if (item.type_id==12){
        store.navTo(`/${URLPRIFIX}/litigation/${tablename}/view/${item.task_id}`);
      }
      else{
        store.navTo(`/${URLPRIFIX}/trademark/${tablename}/view/${item.task_id}`);
      }
    }
  };

  const handleSort = (label) => {
    setSortConfig((prev) => ({
      field: label,
      direction:
        prev.field === label && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const records = store.getvalue("list") || [];

  const filteredRecords = records
    .filter((record) =>
      Header.every(([_, label]) => {
        const filterValue = filters[label];
        if (!filterValue) return true;

        let fieldValue = record[label];
        if (label.toLowerCase().includes("date") && fieldValue) {
          const parsed = new Date(fieldValue);
          if (!isNaN(parsed)) fieldValue = parsed.toISOString().split("T")[0];
        } else if (label === "hasBadge") { // Special handling for the "Badge" column
            return filterValue.toLowerCase() === "true" ? fieldValue : !fieldValue;
        }

        return (
          fieldValue &&
          fieldValue.toString().toLowerCase().includes(filterValue.toLowerCase())
        );
      })
    )
    .sort((a, b) => {
      const { field, direction } = sortConfig;
      if (!field) return 0;

      const aVal = (a[field] ?? "").toString().toLowerCase();
      const bVal = (b[field] ?? "").toString().toLowerCase();

      if (aVal < bVal) return direction === "asc" ? -1 : 1;
      if (aVal > bVal) return direction === "asc" ? 1 : -1;
      return 0;
    });

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      handleOnSelect(filteredRecords, true);
    } else {
      handleOnSelect([], false);
    }
  };

  const isAllSelected =
    filteredRecords.length > 0 &&
    selectedRecords.length === filteredRecords.length &&
    filteredRecords.every((record) =>
      selectedRecords.some((sItem) => sItem.id === record.id)
    );

  const isSelected = (item) => selectedRecords.some((sItem) => sItem.id === item.id);

  const selectedField = store.getvalue("filterfield");
  const currentSort = store.getvalue("sort");
   if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 font-inter">
        <div className="flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-lg">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#8B5CF6] mb-4"></div>
          <p className="text-lg text-gray-700">Loading ...</p>
        </div>
      </div>
    );
  }
 function GetListview({
    listUrl = "",
    field = "",
    search = "",
    sort = "",
    page = 1,
    count = 10,
    store,
    pagesize = 20,
  }) {
    let token = getlocal("system").token;
    let url = "";
    if (field !== "") url += "&fieldname=" + field;
    if (search !== "") url += "&search=" + search;
    if (sort !== "") url += "&sort=" + sort;
    if (page !== "") url += "&page=" + page;
    if (count !== "") url += "&count=" + count;
    if (pagesize !== "") url += "&pagesize=" + pagesize;
    url = url.substring(1, url.length);
    url = `${baseurl}${listUrl}?${url}`;

    axios
      .get(url, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setLoading(false);
        res = res?.data;
        let count = res?.totalCount;
        let statuscount = res?.statuscount;

        let totalCount = res?.totalCount / pagesize;

        if (totalCount % 1 == 0) {
          totalCount = Math.floor(totalCount);
        } else {
          totalCount = Math.floor(totalCount) + 1;
        }

        store.setvalue("totalpage", totalCount);
        store.setvalue("currentpage", page);
        store.setvalue("pagesize", pagesize);

        // Add a 'hasBadge' property to each task item based on your logic
        // For demonstration, let's assume a task has a badge if its 'approved_by' field is not empty.
        // You'll need to adjust this logic based on your actual data structure and badge criteria.
        const listWithBadges = res?.list?.map(item => ({
          ...item,
          hasBadge: !!item.approved_by // Example logic: if approved_by exists, it has a badge
        }));
        store.setvalue("list", listWithBadges);

        setHasNoRecords(listWithBadges?.length === 0); // Set hasNoRecords based on the list length

        let head = Object.keys(res?.list[0] || []);
        head?.splice(5, 0, "ACTION");
        store.setvalue("header", head);
        store.setvalue("totalrecords", count);
        store.setvalue("statuscount", statuscount);
      })
      .catch((res) => {
        console.error("Error Response", res);
        setHasNoRecords(true); 
        setLoading(false);
      });
  }
  return (
    <div className="w-full bg-[#f8fafc] px-6 py-6" style={{ minHeight: '100vh', paddingBottom: '120px' }}>
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-black tracking-tight" style={{ color: '#4F46E5', fontFamily: 'Inter, sans-serif' }}>
            Earned Badges Master
          </h1>
          <p className="text-xs font-semibold text-slate-500 mt-1">
            Browse and search user tasks completed with badges.
          </p>
        </div>
      </div>

      <div className="flex flex-wrap justify-between items-center mb-4 px-2">
        <div className="flex flex-wrap gap-1 max-w-full">
          {statusTabs?.map((tab) => (
            <button
              key={tab.status}
              onClick={() => {
                setActiveTab(tab.status);
                change({
                  field: "status",
                  search: tab.status === "ALL" ? "" : tab.status,
                  pagesize: tab.count,
                  sort: store.getvalue("sort"),
                });
              }}
              className={`text-xs px-3.5 py-1.5 rounded-full font-bold border transition duration-200 cursor-pointer ${
                activeTab === tab.status
                  ? "bg-[#4F46E5] text-white border-[#4F46E5]"
                  : "bg-white text-slate-600 border-slate-200 hover:bg-slate-50"
              }`}
            >
              {tab.status} ({tab.count})
            </button>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-lg overflow-hidden flex flex-col mb-8" style={{ boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05)' }}>
        {hasNoRecords ? (
          <div className="flex flex-col items-center justify-center py-20 text-slate-400 gap-2">
            <FaStar size={28} className="text-amber-400" />
            <p className="text-xs font-semibold">No badges earned for this user yet.</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse" style={{ minWidth: '1000px' }}>
              <thead>
                {/* Clean Light High-Visibility Header */}
                <tr style={{ backgroundColor: '#EEF2FF', borderBottom: '2px solid #E2E8F0' }}>
                  <th className="px-4 py-4.5 w-16 text-[10px] font-black uppercase tracking-widest text-slate-500 pl-6">
                    S.No.
                  </th>
                  <th className="pl-6 py-4.5 w-12 text-left">
                    <input
                      type="checkbox"
                      onChange={handleSelectAll}
                      checked={isAllSelected}
                      className="rounded border-slate-300 h-4.5 w-4.5 cursor-pointer accent-[#6366F1]"
                    />
                  </th>
                  {Header.map(([name, label], index) => {
                    return (
                      <th key={index} className="px-6 py-4.5 text-[10px] font-black uppercase tracking-widest cursor-pointer group text-slate-600 hover:text-[#4F46E5]" onClick={() => handleSort(label)}>
                        <div className="flex items-center gap-1.5">
                          <span>{name}</span>
                          {sortConfig.field === label && (
                            <span className="font-extrabold text-[#4F46E5]">{sortConfig.direction === "asc" ? " ↑" : " ↓"}</span>
                          )}
                        </div>
                        {/* Filter Inputs */}
                        <div className="relative w-full mt-1.5" onClick={(e) => e.stopPropagation()}>
                          {label === "hasBadge" ? (
                            <select
                              className="text-xs bg-white border border-slate-200 rounded px-2 py-1 text-slate-600 focus:outline-none"
                              value={filters[label] || ""}
                              onChange={(e) =>
                                setFilters((prev) => ({
                                  ...prev,
                                  [label]: e.target.value,
                                }))
                              }
                            >
                              <option value="">All</option>
                              <option value="true">Yes</option>
                              <option value="false">No</option>
                            </select>
                          ) : (
                            <input
                              type={label.toLowerCase().includes("date") ? "date" : "text"}
                              placeholder="-"
                              className="block w-full px-2 py-1 bg-white border border-slate-200 rounded text-[11px] text-slate-800 placeholder-slate-400 focus:outline-none"
                              value={filters[label] || ""}
                              onChange={(e) =>
                                setFilters((prev) => ({
                                  ...prev,
                                  [label]: e.target.value,
                                }))
                              }
                            />
                          )}
                        </div>
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {filteredRecords.map((item, index) => {
                  const selected = isSelected(item);
                  return (
                    <tr
                      key={item.id || index}
                      className="hover:bg-slate-50/80 transition-all duration-150 cursor-pointer"
                      style={{
                        backgroundColor: selected ? '#EEF2FF' : 'transparent',
                        borderBottom: '1px solid #F1F5F9'
                      }}
                    >
                      <td className="px-4 py-3.5 text-xs font-semibold text-slate-400 pl-6">
                        <span className="inline-flex items-center justify-center bg-slate-100 text-slate-600 font-bold text-xs px-2 py-0.5 rounded">
                          {index + 1}
                        </span>
                      </td>
                      <td className="pl-6 py-3.5" onClick={(e) => e.stopPropagation()}>
                        <input
                          type="checkbox"
                          onChange={(event) => {
                            handleOnSelect(item, event.target.checked);
                          }}
                          checked={selected}
                          className="rounded border-slate-300 h-4 w-4 cursor-pointer accent-[#6366F1]"
                        />
                      </td>
                      {Header.map(([name, label], fieldindex) => {
                        if (label.toLowerCase().includes("date")) {
                          const dateValue = item[label];
                          let displayDate = '---';

                          if (typeof dateValue === 'string' && dateValue) {
                            const [date] = dateValue.split("T");
                            displayDate = date;
                          }

                          return (
                            <td key={fieldindex} className="px-6 py-3.5 text-xs font-semibold text-slate-500" onClick={() => handleClickRow && handleClickRow(item)}>
                              {displayDate}
                            </td>
                          );
                        } else if (label === "hasBadge") {
                          return (
                            <td key={fieldindex} className="px-6 py-3.5" onClick={() => handleClickRow && handleClickRow(item)}>
                              {item.hasBadge ? <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold bg-amber-50 text-amber-700 border border-amber-200">⭐ Earned</span> : null}
                            </td>
                          );
                        } else {
                          return (
                            <td key={fieldindex} className="px-6 py-3.5 text-xs font-bold text-slate-700" onClick={() => handleClickRow && handleClickRow(item)}>
                              {item[label]?.toString()?.charAt(0)?.toUpperCase() +
                                item[label]?.toString()?.slice(1)}
                            </td>
                          );
                        }
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {!hasNoRecords && (
          <div className="flex items-center justify-end px-6 py-4 border-t border-slate-100 bg-[#fcfcfe]">
            <Pagination onchange={onpage} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BadgeTaskList;